import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Shared modules
import { CoreModule } from '../core';
import { SharedModule } from '../shared';
import { UIModule } from '../ui.module';
import { SharedDialogsModule } from '../shared-dialogs.module';
import { SharedServicesModule } from '../shared-services.module';
import { ToastrModule } from '../toastr.module';

import { ArenaRoutingModule } from './arena.routing';

// Components of module.
import { ArenaComponent } from './arena.component';
import { NotEnoughAccessKeysComponent } from './not-enough-access-keys.component';
import { DlgNotEnoughAccessKeysComponent } from './dlg-not-enough-access-keys';

// Services of module.
import { ArenaService } from './arena.service';
import { ShowDlgNotEnoughAccessKeysService } from './show-dlg-not-enough-access-keys.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        // Shared modules
        SharedModule,
        UIModule,
        SharedDialogsModule,
        SharedServicesModule,
        ToastrModule,
        // Current module imports
        ArenaRoutingModule
    ],
    declarations: [
        // Section Components
        ArenaComponent,
        NotEnoughAccessKeysComponent,
        DlgNotEnoughAccessKeysComponent
    ],
    entryComponents: [
        DlgNotEnoughAccessKeysComponent
    ],
    providers: [
        ArenaService,
        ShowDlgNotEnoughAccessKeysService
    ]
})
export class ArenaModule { }
